<template>
    <div class="relative bg-wrap-color ">
        <div v-if="!mixinLoading" class="p10">
            <template v-if="isPageAllowed">
                <keep-alive :include="keepList">
                    <component
                        :is="componentName"
                        @changePage="handleChangePage"
                        :query="query"
                        :reload="reload"
                        :data="actionData"
                        :type="actionType"
                        :pageFuncNames="tabFuncNames"
                        :allowedPlatList="allowedPlatList"
                    />
                </keep-alive>
            </template>
            <template v-else>
                <NoPermissionInfo>
                    <p>广告批量调控</p>
                </NoPermissionInfo>
            </template>
        </div>
    </div>
</template>

<script>
import AdBatchAdjustmentPage from './pages/ads/index.vue'
import TaskPage from './pages/task'
import NoPermissionInfo from "@/components/noPermissionInfo.vue";
import {pageMixin} from '../../mixins/pageMixin';
export default {
    name: 'toolAds',
    mixins: [pageMixin],
    components: {
        NoPermissionInfo,
        AdBatchAdjustmentPage,
        TaskPage
    },
    data() {
        return {
            componentName: 'AdBatchAdjustmentPage',
            keepList:['AdBatchAdjustmentPage'],
            query: {}, //传入对象
            reload: '', //更新接口
            actionData:{},
            actionType:'',
        }
    },
    computed:{
        tabFunc(){
            let actionTab = (this.pageAction||[]).find(item=> item.name === 'ad_batch_adjustment_page');
            if(actionTab){
                return actionTab.func||[];
            }
            return [];
        },
        tabFuncNames(){
            return (this.tabFunc||[]).map(item=>item.name);
        },
        pageNames() {
            return (this.pageAction||[]).map(item=>item.name)
        }
    },
    created() {
        // 由列队页面跳转任务管理-工单想请你
        // if(this.$route.query.topage === 'StorePage') {
        //     //material_type 数组 1:图片 2:视频
        //     this.handleChangePage(this.$route.query.topage, {material_type:'', project_id: 3})
        // }
    },
    watch: {
      'mixinLoading': {
          handler(n) {
              if(!n) {
                  let current_auth_name = this.pageNames.length !== 0 ? this.pageNames[0] : '';
                  if(this.pageNames.indexOf(current_auth_name) !== -1) {
                      this.componentName = this.toPascalCase(current_auth_name)
                      this.query = this.$route.query
                  }
              }
          }
      }
    },
    methods:{
        // 把页面返回的权限名转换成驼峰命名 （如：work_order_assign_list => WorkOrderAssignList）
        toPascalCase(str) {
            return str
                .split('_')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join('');
        },
        /**
         *
         * @param url    跳转的页面
         * @param params  参数传递 对象
         * @param type  页面刷新方式 true  false
         */
        handleChangePage(url, params, type) {
            this.componentName = url
            this.query = params
            this.reload = type
        }
    }
}
</script>

<style lang="scss" scoped>
.tab-bar::after{
    content: '';
    position: absolute;
    left: -20px;
    right: -20px;
    background-color: #fff;
}
.tab-bar ::v-deep .el-tabs__header{
    background-color: #fff;
    margin-bottom: 10px;
    .el-tabs__nav-wrap{
        padding-left: 30px;
    }
}
.tab-bar ::v-deep .el-tab-pane{
    margin: 0 15px;
}
.bg-wrap-color{
    padding: 0;
    background-color:#F1F4F9;
}
</style>
